import React, { Component } from 'react'
import Input from './../input'
import { PROTOCOL } from './../../lib/helper'
import _ from 'underscore'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

class SandboxFormInputFields extends Component{
	constructor(props){
		super(props)
		this.state = {}
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors, fields } = this.props
		let classname = "col-md-12 col-xs-12"
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}

	title() {
		return (
			<span>
				Sandbox License
				<OverlayTrigger
					placement="right"
					overlay={
						<Tooltip id="license">
							Please enter your Sandbox License key. If you don&#39;t have a license leave the field blank and you can use poopy.life for free.
						</Tooltip>
					}
				>
					<i className="mdi mdi-help-circle" style={{ position: "unset", fontSize: "1.6rem" }}></i>
				</OverlayTrigger>
			</span>
		)
	}

	render(){
		return (
			<div style={{ marginTop: "3rem" }}>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-key"></i>
						<Input
							type="text"
							name="license"
							title={this.title()}
							placeholder="Enter license key"
							classname=""
							value={this.fetchValue('license')}
						/>
					</div>
				</div>
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="sandbox"
						title=""
						placeholder=""
						classname=""
					/>
					<Input
						type="hidden"
						title=""
						name="type"
						placeholder=""
						classname=""
						value="sftp"
					/>
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={PROTOCOL.SFTP}
					/>
				</div>
			</div>
		)
	}
}

export default SandboxFormInputFields
